/**
 * Configuration for the admin-web application
 */

export const GOOGLE_PLACES_API_KEY = (
  process.env.VITE_GOOGLE_PLACES_API_KEY ||
  'AIzaSyCtN2BwBDr6ZntF9BZgxo7yaYDfT47i2YI'
).trim();

export const NODE_ENV = process.env.NODE_ENV || 'development';
